export const convertToLocale = (locale?: string): string => {
  if (!locale) {
    return 'en-GB';
  }

  return locale.split('_').join('-');
};
